module.exports = __webpack_public_path__ + "static/media/logo_orange_full_desktop.8b688b8c.svg";